import {
  AlignItems,
  Body2,
  Box,
  Button,
  ButtonSize,
  Color,
  Display,
  FlexDirection,
  Heading5,
  JustifyContent,
  Space,
  TextAlign,
} from '@gousto-internal/citrus-react'
import { queueTrackingEvent } from '@library/tracking-integration'
import React from 'react'
import { OpenTileMenuWrapper } from './OpenMenuTileWrapper.styled'

type CuratedBoxOpenMenuTileProps = {
  handleOnClickOpenMenu: () => void
}

export const curatedBoxCopy = {
  heading: 'Build your own box',
  subtitle: 'Choose from over 75 delicious dinners',
  buttonCopy: 'Open menu',
}

export const CuratedBoxOpenMenuTile = ({ handleOnClickOpenMenu }: CuratedBoxOpenMenuTileProps) => {
  const trackingData = {
    action: 'click_open_full_menu',
    properties: {
      component: 'open_full_menu',
    },
  }

  const handleOpenMenu = () => {
    handleOnClickOpenMenu()
    queueTrackingEvent<typeof trackingData>(trackingData)
  }

  return (
    <>
      <OpenTileMenuWrapper>
        <Box width="100%" height="100%" paddingH={10} paddingV={10}>
          <Box
            display={Display.Flex}
            flexDirection={FlexDirection.Column}
            justifyContent={JustifyContent.Center}
            alignItems={AlignItems.Center}
            bg={Color.White}
            width="100%"
            height="100%"
            paddingH={4}
            paddingV={[16, null, 4]}
          >
            <Heading5 textAlign={TextAlign.Center}>{curatedBoxCopy.heading}</Heading5>
            <Space size={2} />
            <Body2 textAlign={TextAlign.Center}>{curatedBoxCopy.subtitle}</Body2>
            <Space size={2} />
            <Button size={ButtonSize.Medium} role="button" onClick={handleOpenMenu}>
              {curatedBoxCopy.buttonCopy}
            </Button>
          </Box>
        </Box>
      </OpenTileMenuWrapper>
    </>
  )
}
